module.exports = __webpack_public_path__ + "static/img/zh-TW.92ea15e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imglang/zh-TW.png
// module id = rW8Q
// module chunks = 47